import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import {
  DigitalSubmissionMultiChoice,
  GroundTruthMultiChoice,
  GTMultiChoicePayloadRelax,
  GTMultiChoicePayloadStrict,
  QuestionMultiChoice,
} from '../../../redux/types';

type Props = {
  exerciseGroundTruth: GroundTruthMultiChoice;
  question: QuestionMultiChoice;
  submission?: DigitalSubmissionMultiChoice;
}

const RevealedAnsMultiChoice: React.FC<Props> = ({
  exerciseGroundTruth,
  question,
  submission,
}: Props) => {
  const checkStrictGroundTruth = (
    gtPayload: GTMultiChoicePayloadStrict,
    ds: DigitalSubmissionMultiChoice['answer'],
  ) => {
    const truthArr = Object.entries(gtPayload.truths).map(([id, gtTruth]) => {
      const userTruth = ds[Number(id)];
      return gtTruth === !!userTruth;
    });
    return (!truthArr.includes(false));
  };

  const checkRelaxGroundTruth = (
    gtPayload: GTMultiChoicePayloadRelax,
    ds: DigitalSubmissionMultiChoice['answer'],
  ) => {
    const achievedScoreArr = Object.entries(ds).map(([id, userTruth]) => {
      const score = gtPayload.truths[Number(id)];
      return userTruth ? score : 0;
    });
    return achievedScoreArr.reduce((acc, cur) => (acc + cur), 0);
  };

  let finalAnswer = false;
  if (exerciseGroundTruth.payload.strict) {
    finalAnswer = checkStrictGroundTruth(exerciseGroundTruth.payload, submission?.answer || {});
  } else {
    finalAnswer = !!checkRelaxGroundTruth(exerciseGroundTruth.payload, submission?.answer || {});
  }

  return (
    <Box aria-label="exercise-answer-multi-choice">
      {
        finalAnswer !== null && finalAnswer !== undefined && (
          <Box>
            {
              !finalAnswer && (
                <Typography style={{ color: 'red', fontWeight: 500 }} component="div">Wrong Answer</Typography>
              )
            }
            {
              finalAnswer && (
                <Typography style={{ color: 'green', fontWeight: 500 }} component="div">Acceptable Answer</Typography>
              )
            }
          </Box>
        )
      }
      {
        exerciseGroundTruth.payload.strict
        && question.payload?.filter((op) => exerciseGroundTruth.payload.truths[op.id]).map((op) => (
          <Box key={op.id} display="flex" gap={2}>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              color="GrayText"
              maxWidth={250}
            >
              {op.text}
            </Typography>
          </Box>
        ))
      }
      {
        !exerciseGroundTruth.payload.strict && question.payload?.map((op) => (
          <Box key={op.id} display="flex" gap={2}>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              color="GrayText"
              maxWidth={250}
            >
              {op.text}
            </Typography>
            <Typography>
              {exerciseGroundTruth.payload.truths[op.id]}
            </Typography>
          </Box>
        ))
      }
    </Box>
  );
};

export default RevealedAnsMultiChoice;
